import React from 'react';
import { PropTypes } from 'prop-types';
import Spritesheet from 'react-responsive-spritesheet';

const SpriteAnimation = ({ styles }) => (
    <div className={styles.sprite}>
        <Spritesheet
            className={styles.spriteElement}
            image={`/images/hp/home_intro.jpg`}
            widthFrame={1248}
            heightFrame={1248}
            steps={24}
            fps={24}
            autoplay={false}
            loop={false}
            isResponsive
            onMouseEnter={spritesheet => {
                spritesheet.setDirection('forward');
                const currentFrame = spritesheet.getInfo('frame');
                console.log(currentFrame === -1 ? 0 : currentFrame);
                spritesheet.goToAndPlay(currentFrame < 0 || currentFrame > 23 ? 0 : currentFrame);
            }}
            onMouseLeave={spritesheet => {
                spritesheet.setDirection('rewind');
                const currentFrame = spritesheet.getInfo('frame');
                spritesheet.goToAndPlay(currentFrame < 0 || currentFrame > 23 ? 23 : currentFrame);
            }}
        />
    </div>
);

SpriteAnimation.propTypes = {
    styles: PropTypes.shape({
        sprite: PropTypes.string.isRequired,
    }).isRequired,
};

export default SpriteAnimation;
